import { H2 } from '@ahmdigital/ui';
import React from 'react';

import {
  ContentWrapper,
  MaxTravellerCountP,
  PromoField,
  PromoLabel,
  PromoLabelWrapper,
  PromoP,
  StyledCheckbox,
  StyledClickable,
} from './styles';
import getTravelInsuranceConstants from '../../../../../../utils/get-travel-insurance-constants';
import TravellerCounter from './components/traveller-counter';
import TravellerField from './components/traveller-field';
import useTravelWidgetContext from '../../hooks/use-travel-widget-context';

const MAX_TRAVELLER_COUNT = 9;

const { CONTACT } = getTravelInsuranceConstants();

const TravellerDetails = () => {
  const { travellerCount, setTravellerCount } = useTravelWidgetContext();

  return (
    <ContentWrapper>
      <H2 looksLike="h5" variant="marginBottomSpacer9">
        Traveller details
      </H2>
      <TravellerField
        helperText="Current age of traveller"
        labelText="Primary traveller"
        name="travelerAge_1"
        required
      />
      {travellerCount === MAX_TRAVELLER_COUNT && (
        <MaxTravellerCountP>
          If there are more than 10 travellers please contact our Customer Service team on{' '}
          <StyledClickable to={`tel:${CONTACT.PHONE.STANDARD}`}>{CONTACT.PHONE.PRETTY}</StyledClickable> to discuss your
          travel insurance options.
        </MaxTravellerCountP>
      )}
      <TravellerCounter travellerCount={travellerCount} setTravellerCount={setTravellerCount} />
      {Array.from({ length: travellerCount }, (_, index) => {
        const travellerIndex = index + 2;
        return (
          <TravellerField
            key={index}
            labelText={`Traveller ${travellerIndex}`}
            name={`travelerAge_${travellerIndex}`}
            helperText={`Current age of traveller ${travellerIndex}`}
            id={`traveller-${travellerIndex}`}
          />
        );
      })}
      <StyledCheckbox
        fieldLabel="All travellers currently live in Australia and hold a valid Australian Medicare card or visa allowing them to live, work or study in Australia."
        name="resident"
        type="checkbox"
        isRequired
      />
      <StyledCheckbox fieldLabel="Are you an ahm or Medibank member?" name="isMember" type="checkbox" />

      <PromoLabelWrapper>
        <PromoLabel htmlFor="promoCode">Promo code </PromoLabel>
        <PromoP>(Optional)</PromoP>
      </PromoLabelWrapper>
      <PromoField name="promoCode" type="text" />
    </ContentWrapper>
  );
};

export default TravellerDetails;
